export default __webpack_public_path__ + "static/media/website.69626789.svg";